<div class="container">
    <span (click)="showContextMenu($event)" class="title">{{showStatusName}}
        <smart-icon name="angle-down" class="angle-down" (click)="showContextMenu($event)"></smart-icon>
    </span>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
</div>